// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3OIff","buttons":"Footer_buttons__3Sfmt"};